import { REHYDRATE } from 'redux-persist';
import update from 'immutability-helper';
import {
  ANY_FIELD_UPDATE,
  FORMFIELD_UPDATE,
  NESTED_RECORD_ADD,
  NESTED_RECORD_REMOVE,
  updatedObject,
} from 'actions/formActions';

import { LOGOUT } from 'actions/loginStateActions';
import {
  SUPPLIER_PROFILE_SUBMIT_BEGIN,
  SUPPLIER_PROFILE_SUBMIT_SUCCESS,
  SUPPLIER_PROFILE_UPLOAD_BEGIN,
  SUPPLIER_PROFILE_SUBMIT_FAIL,
} from './supplier/types';
import {
  COMPANY_PROFILE_INIT,
  COMPANY_PROFILE_FETCH_BEGIN,
  COMPANY_PROFILE_FETCH_SUCCESS,
  COMPANY_PROFILE_FETCH_FAIL,
  COMPANY_PROFILE_SUBMIT_BEGIN,
  COMPANY_PROFILE_SUBMIT_SUCCESS,
  COMPANY_PROFILE_SUBMIT_FAIL,
  DELETE_AUDIT_CERT,
  COMPANY_PROFILE_RESET_STATUS,
} from './types';

import INITIAL_STATE from './state';

export default function companyProfileWorkspaceReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REHYDRATE:
      return state;

    case COMPANY_PROFILE_INIT:
      return { data: INITIAL_STATE.data, status: 'editing' };

    case COMPANY_PROFILE_FETCH_BEGIN:
      return { data: {}, status: 'fetching' };

    case COMPANY_PROFILE_FETCH_SUCCESS:
      return update(state, {
        data: {
          $set: {
            ...action.data,
            productLiabilityInsurance: action.data.productLiabilityInsurance ? 'yes' : 'no',
            topMarkets: action.data.topMarkets
              ? action.data.topMarkets
              : INITIAL_STATE.data.topMarkets,
            productCategories: action.data.productCategories
              ? action.data.productCategories
              : INITIAL_STATE.data.productCategories,
            majorCustomers: action.data.majorCustomers
              ? action.data.majorCustomers
              : INITIAL_STATE.data.majorCustomers,
            companyCertifications: action.data.companyCertifications
              ? action.data.companyCertifications
              : INITIAL_STATE.data.companyCertifications,
            yearEstablished: action.data.yearEstablished
              ? action.data.yearEstablished.toString()
              : '',
            insuranceCountries: action.data.country
              ? action.data.country
              : INITIAL_STATE.data.country,
            deletedAuditCerts: [],
          },
        },
        status: { $set: 'editing' },
      });

    case COMPANY_PROFILE_FETCH_FAIL:
      return { data: {}, status: 'failed', failReason: action.reason };

    case ANY_FIELD_UPDATE: {
      if (action.storeName !== 'companyProfileWorkspace') return state;

      return {
        ...state,
        data: updatedObject(state.data, action.accessPath, action.newVal),
      };
    }

    case FORMFIELD_UPDATE: {
      if (action.storeName !== 'companyProfileWorkspace') return state;

      return {
        ...state,
        data: {
          ...state.data,
          [action.fieldName]: action.newVal,
        },
      };
    }

    case NESTED_RECORD_ADD: {
      if (action.storeName !== 'companyProfileWorkspace') return state;

      return {
        ...state,
        data: {
          ...state.data,
          [action.fieldName]: [...state.data[action.fieldName], {}],
        },
      };
    }

    case NESTED_RECORD_REMOVE: {
      if (action.storeName !== 'companyProfileWorkspace') return state;

      return {
        ...state,
        data: {
          ...state.data,
          [action.fieldName]: state.data[action.fieldName].filter(
            (item, idx) => idx !== action.idx
          ),
        },
      };
    }

    // case ANYFIELD_NESTED_RECORD_ADD: {

    //     if (action.storeName !== 'companyProfileWorkspace')
    //         return state;

    //     return {
    //         ...state,
    //         data: updatedObject(state.data, action.accessPath, {[action.key]:[action.value]})
    //     }
    // }

    case COMPANY_PROFILE_SUBMIT_BEGIN:
      return { ...state, status: 'submitting' };

    case COMPANY_PROFILE_SUBMIT_SUCCESS:
      return { ...state, status: 'uploading' };

    case COMPANY_PROFILE_SUBMIT_FAIL:
      return { ...state, status: 'failed', failReason: action.reason };

    case SUPPLIER_PROFILE_SUBMIT_BEGIN:
      return { ...state, status: 'submitting' };

    case SUPPLIER_PROFILE_SUBMIT_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.supplierId,
        },
        status: 'submitting',
      };

    case SUPPLIER_PROFILE_UPLOAD_BEGIN:
      return { ...state, status: 'uploading' };

    case SUPPLIER_PROFILE_SUBMIT_FAIL:
      return { ...state, status: 'failed', failReason: action.reason };

    case DELETE_AUDIT_CERT:
      return update(state, { data: { deletedAuditCerts: { $push: [{ id: action.id }] } } });

    case COMPANY_PROFILE_RESET_STATUS: {
      const { failReason, ...newState } = state;
      return { ...newState, status: 'viewing' };
    }

    case LOGOUT:
      return { data: {}, status: 'uninitialized' };

    default:
      return state;
  }
}
